import 'reflect-metadata';
import './app.scss';
import CareApp from './care-app';
import ConsentApp from './consents-app';
import { MobileProvider } from 'utilities/mobile-context';
import { ToastProvider } from 'react-components/app/ReusableToast';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { routes } from './routing/routes';

const AppWrapper = () => {
  const host = window.location.host;
  const parts = host.split('.');
  const subdomain = parts[0];

  return subdomain === 'consent' ? <ConsentApp /> : <CareApp />;
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppWrapper />,
    children: routes[0].children,
  },
  {
    path: '/:termKey',
    element: <ConsentApp />,
  },
]);

const App = () => {
  return (
    <MobileProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </MobileProvider>
  );
};

export default App;
